import axiosClient from "@/config/AxiosClient"

export const UtilitiesService = {
  timezones
}

function timezones() {
  return axiosClient.get("api/2.0/utilities/timezone")
}
